module.exports = __webpack_public_path__ + "assets/icons/translated_with_DeepL_EN-5d35.svg";